"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Image = (props) => {
    const testId = `${props.testId}-Image`;
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { className: props.className || '', "data-testid": testId, src: props.src, alt: props.alt, onLoad: props.handleImageLoaded, onError: props.handleImageError, width: props.width, height: props.height }), props.children] }));
};
exports.Image = Image;
